/**
 * Country options used by container origin/destination pickers.
 * ISO2 lowercase to match the server's `cargo_containers.origin_country`
 * + `destination_country` storage shape.
 *
 * Subset of CONTAINER_ISO2_LIST (server/config/supportedCountries.js)
 * — only countries we expect to surface in the picker. Add more here
 * as cargo international corridors light up.
 */
export interface CountryOption {
  code: string;       // ISO2 lowercase
  name: string;       // Arabic display name
}

export const CONTAINER_COUNTRIES: CountryOption[] = [
  { code: 'cn', name: 'الصين' },
  { code: 'tr', name: 'تركيا' },
  { code: 'ae', name: 'الإمارات' },
  { code: 'sy', name: 'سوريا' },
  { code: 'lb', name: 'لبنان' },
  { code: 'jo', name: 'الأردن' },
  { code: 'sa', name: 'السعودية' },
  { code: 'eg', name: 'مصر' },
  { code: 'iq', name: 'العراق' },
  { code: 'ly', name: 'ليبيا' },
];
